import iconFile from '../../assets/images/icon_data.gif';
import { ItemDataSubTypes } from '../../lib/ItemUtil';
import TopBase, { type TopBaseProps } from '../lib/TopBase';

class DataTop extends TopBase {
    constructor(props: TopBaseProps) {
        super(props);
        this.type = 'data';
        this.label = 'Data';
        this.icon = iconFile;
        this.description =
            '[en]Data from experiments or simulations.[/en][ja]実験やシミュレーションで得られたデータ[/ja]';
        this.subTypes = ItemDataSubTypes;
    }
}

export default DataTop;
